<template>
  <label :for="`${props.id}_${props.name}`" 
         class="h-16 py-2 px-4 mr-2 mb-2
              flex flex-col items-center justify-center
              border border-solid border-ryd-blue5 rounded-md 
              font-medium focus-visible:outline-text-highlight-secondary"
         :class="props.checked ? 'bg-ryd-blue5 text-white' : 'bg-ryd-blue0 text-ryd-blue5'"
         @keydown.enter="model = props.value"
  >
    <RydIcon :icon="props.icon" class="w-9 h-8" isCustomColor customColor="text-ryd-blue5" />

    {{ props.label }}
    <input :id="`${props.id}_${props.name}`" 
           v-model="model" 
           type="radio" 
           class="hidden" 
           :value="props.value"
           :name="props.name"
           :checked="props.checked"
    />
  </label>
</template>
<script lang="ts" setup>
import RydIcon from '../RydIcon/RydIcon.vue';

const props = defineProps({
  label: {
    type: [String, Number],
    default: ''
  },
  name: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number, Object],
    required: true
  },
  id: {
    type: String,
    default: () => '',
  },
  checked: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: '',
  }
});

const model = defineModel();

</script>

